import React, { useEffect, useState } from "react";
import { connect } from 'react-redux'
import * as actions from '../../../../store/actions'
import { modalActions, commonActions, alertActions, inboxActions} from "../../../../store/actions";
import CertificateAddDoc from "../inbox/CertificateAddDoc";
import CertificateReceiver from "../inbox/CertificateReceiver";
import { Link } from "react-router-dom";
import moment from "moment";
import history from "../../../../route/history";

const CerficateReceiverModal = props => {
    const [ state, setState ] = useState({});
    const [ receiverList, setReceiverList] = useState([]);
    const [ crtDvList, setCrtDvList ] = useState([]);
    const [ crtStsCdList, setCrtStsCdList ] = useState([]);
    const [ addList, setAddList] = useState([]);

    useEffect(() => {   
   
     }, []);  
    
    const getReceiverList = (receiverList) => {
        setReceiverList(receiverList);
      }
    useEffect(() => {
      
      if (!props.commoncode) return;
      if(props.commoncode?.co.CRT_DV){
        
        setCrtDvList(
          props.commoncode?.co.CRT_DV
        )
      };
     
      if(props.commoncode?.co.CRT_STS_CD){
        
        setCrtStsCdList(
          props.commoncode?.co.CRT_STS_CD
        )
      };
      
    }, [props.commoncode]);

      

    const makeCrtCd = (crtCd) => {
        const list = crtDvList?.find((crtDv) => crtDv?.cd === crtCd);

        return list? '[' + list.cdName + ']' : '';
    }

    const makeCrtStsCd = (sts) => {
        const list = crtStsCdList?.find((crtSts) => crtSts.cd === sts);

        return list? list.cdName : '';
    }
    const getAddList = (addList) => {
        setAddList(addList);
      }
    useEffect(() => {
      if (props.isSubmit) {
        props.success({
          title: '제출성공',
          message: '성공적으로 제출되었습니다.',
          params: {
            type: 'SUCCESS',
            callback: () => {
              props.clearModal();
            }
          }
        })
      }
    }, [props.isSubmit]);
    const onSubmit = () => {
        // 증명서 보내기
        // 1. 업체id, 전자문서코드, 첨부파일, 제출처 전자지갑 주소를 입력받아 필수 입력항목 체크
        // 2. 증명서 송신 api 호출(처리결과 메시지 출력)
        // 3. 목록으로 이동
    
        if (receiverList.length < 1) {
          props.error({message: '수신 대상이 존재하지 않습니다.'});
          return;
        }
    
        let submitObj = {
          crtSeq: props.modal.params.map(param => param.crtSeq),
          files: addList,
          ewalletIds: receiverList.map(receiver => receiver.ewalletId)
        }
    
        props.createCrtfSubmit(submitObj);
      }
    return (

        <React.Fragment>
            {
                props.modal.isShow ?

            <div className="modal-overlay">
                <div className="modal modal-Full ">
                    <div className="modal-content">
                        <div className="modal-header">
                            <div className="modal-title ">
                            증명서 제출
                            </div>
                            <button
                                type="button"
                                className="icon-close"
                                data-dismiss="modal"
                                aria-label="Close"
                                onClick={() => props.clearModal(true)}
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body cerficate-receiver-popup">
                            <div className="detail-table">
                            {/* modal-body */}
                            {
                             props.modal.params?.length > 0 ? props.modal.params?.map((inboxInfo, index) => (
                            <div className="detail-table-box">
                                <div className="detail-title">증명서</div>
                                <div className="detail-table-scroll">
                                    <div className="inner">
                                    <div className="scroll">
                                        <div className="row" style={{width: "100%"}}>
                                        <ul className="flex-col">
                                            <li className="flex-sb w-full ">
                                            <div className="flex-row w-full item">
                                                <span className="title w-50">{makeCrtCd(inboxInfo.crtCd)} - {makeCrtStsCd(inboxInfo.sts)}</span>
                                                <span className="w-50 text-right">{moment(inboxInfo.issuedt, 'YYYYMMDDhhmmss').format('YYYY.MM.DD HH:mm:ss')}</span>
                                            </div>
                                            </li>
                                            <li className="flex-sb w-full">
                                            <div className="flex-row w-full item">
                                                <span className="">{inboxInfo.docid}</span>
                                            </div>
                                            </li>
                                            <li className="flex-sb w-full">
                                            <div className="flex-row w-full item">
                                                <span className="w-50">{inboxInfo.prchsNm}</span>
                                                <span className="w-50 text-right">{inboxInfo.gramt}</span>
                                            </div>
                                            </li>
                                        </ul>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                            </div>
                            ))
                            :  <div className="noData">조회 결과가 없습니다.</div>
                            }
                             {props.modal.params?.length === 1 ? 
                            <CertificateAddDoc getAddList={getAddList}/>
                            : ''}
                            {/* 수신자 */}
                            <CertificateReceiver getReceiverList={getReceiverList}/>

                            <div className="btn-area ">
                                <button className="btn btn-dark-blue" onClick={onSubmit}>증명서 보내기</button>
                            </div>                            
                            
                        {/* end of modal-body */}
                        </div>
                        </div>
                    </div>
                </div>
            </div>

                :''
            }

        </React.Fragment>
    )
}


const mapStateToProps = state => {
    return {
      inboxInfo: state.inbox?.info,
      isSubmit: state.inbox?.isSubmit,
      commoncode: state.commoncode,
      modal: state.modal,
    }
  }

const actionCreators = {
   clearModal:modalActions.clearModal,
   createCrtfSubmit: inboxActions.createCrtfSubmit,
   success: alertActions.success,
   common: commonActions.getCommonCode,
   error: alertActions.error,
}

export default connect(
    mapStateToProps,
    actionCreators
)(CerficateReceiverModal)




